import { render, staticRenderFns } from "./billings-balances-inquiry.vue?vue&type=template&id=5308b7d2&"
import script from "./billings-balances-inquiry.vue?vue&type=script&lang=js&"
export * from "./billings-balances-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports